import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarEmpresasAutorizadasUsuario(api) {
    parametros = {
      operacao: 'buscarEmpresasAutorizadasUsuario'
    };

    let retorno = {};

    await api.santriGET('/rest/empresa', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarTodasEmpresas(api) {
    let parametros = {
      operacao: 'buscarTodasEmpresas'
    };

    let retorno = {};

    await api.santriGET('/rest/empresa', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarEmpresasSugestao(api) {
    let parametros = {
      operacao: 'buscarEmpresasSugestao'
    };

    let retorno = {};

    await api.santriGET('/rest/empresa', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REmpresa.js